import { Component, OnDestroy, OnInit } from '@angular/core';
import { IEvent } from '../models/IEvent';
import { Observable, Subscription } from 'rxjs';
import { EventService } from '../services/event.service';
import { ThemeService } from '../services/theme.service';
import { ITheme } from '../models/ITheme';

@Component({
  selector: 'app-own-items',
  templateUrl: './own-items.component.html',
  styleUrls: ['./own-items.component.scss']
})
export class OwnItemsComponent implements OnInit, OnDestroy {

  allOwn: any[] = [];
  filteredItems: any[] = [];
  subscription: Subscription;
  themes$: Observable<any>;
  PLACEHOLDER_IMAGE = 'https://firebasestorage.googleapis.com/v0/b/froodini-d5dad.appspot.com/o/placeholder.jpg?alt=media&token=16ef0fe2-9a67-4fef-91ef-1910417ec165';

  constructor(private eventService: EventService, private themeService: ThemeService) { }

  ngOnInit(): void {
    this.themes$ = this.themeService.getAll();
    this.subscription = this.eventService.getAllOwn().subscribe(res => {
      res.forEach(ob => {
        if (ob.items.length > 0) {
          ob.items.forEach(item => {
            if (item.id.length < 15) {
              this.themeService.get(ob.theme).subscribe(themeRes => {
                this.allOwn.push({theme: themeRes.name.toLowerCase(), ...item});
                this.filteredItems.push({theme: themeRes.name.toLowerCase(), ...item});
              });
            }
          });
        }
      });
    });
  }

  filter(field: string, value: string) {
    this.filteredItems = this.allOwn.filter(i => i[field].toLowerCase().includes(value.toLowerCase()));
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }

}
